import { render, staticRenderFns } from "./ContractAdd.vue?vue&type=template&id=d527af6c&scoped=true"
import script from "./ContractAdd.vue?vue&type=script&lang=ts"
export * from "./ContractAdd.vue?vue&type=script&lang=ts"
import style0 from "./ContractAdd.vue?vue&type=style&index=0&id=d527af6c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d527af6c",
  null
  
)

export default component.exports